import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetSiteIdentity } from '@/application/services/settings.service'
import { useAuthStore } from '@/application/stores/auth.store'
import { getThemeById, envDefaultTheme } from '@/themes'
import { resolveThemeId } from '@/themes/resolve'
import {
  getPublicThemeOverride,
  subscribeToPublicThemeOverride,
} from '@/themes/publicThemeOverride'
import type { Theme } from '@/themes'

const SUPPORTED_LANG_CODES = ['fr', 'en', 'es']

function resolveLanguage(input: string): string {
  const code = input.substring(0, 2).toLowerCase()
  return SUPPORTED_LANG_CODES.includes(code) ? code : 'fr'
}

/** Returns the full Theme object for the currently active theme. */
export function useCurrentTheme(): Theme {
  const { i18n } = useTranslation()
  const { data: settings } = useGetSiteIdentity(resolveLanguage(i18n.language))
  const { isAuthenticated } = useAuthStore()
  const [publicThemeOverride, setPublicThemeOverrideState] = useState(getPublicThemeOverride)

  useEffect(
    () =>
      subscribeToPublicThemeOverride(() => setPublicThemeOverrideState(getPublicThemeOverride())),
    [],
  )

  return getThemeById(
    resolveThemeId(isAuthenticated, settings, envDefaultTheme, publicThemeOverride),
  )
}
